<template>
  <table class="table table-striped table-sm table-bordered" :id="dataTable.id">
    <thead>
      <tr>
        <th class="text-center">#</th>
        <th>Distribuição</th>
        <th>Agendamento</th>
        <th>Validade</th>
        <th>Pesquisas / Respostas</th>
        <th class="text-center">Enviado</th>
        <th class="text-center">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="d in distributions" :key="d.id">
        <td class="text-center">{{ d.id }}</td>
        <td>
          {{ d.name }}
        </td>
        <td>
          <span class="d-none">{{ d.scheduleAt }}</span>
          {{ dateTimeSqlToDateTimeBR(d.scheduleAt) }}
        </td>
        <td>
          <span class="d-none">{{ d.validityAt }}</span>
          {{ dateTimeSqlToDateTimeBR(d.validityAt) }}
        </td>
        <td>{{ d.totalSurvey }} / {{ d.totalAnswered }}</td>
        <td class="text-center">
          <span v-html="isSendTranslate(d.isSend)"></span>
        </td>
        <td class="text-center p-1">
          <router-link
            type="button"
            class="btn btn-outline-info btn-icon"
            title="Editar"
            :to="`/distributions/${d.id}`"
          >
            <i class="ph ph-eye" />
          </router-link>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { isSendTranslate } from '@/utils/strings'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'

export default {
  name: 'ListDistributions',

  props: {
    distributions: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: null,
      dateTimeSqlToDateTimeBR,
      dataTable: {
        id: 'dataTableListDistributions',
        order: [[0, 'DESC']],
        columnDefs: [
          {
            targets: [4, 5, 6],
            orderable: false,
          },
          {
            targets: [6],
            width: 130,
          },
        ],
      },
      isSendTranslate,
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
        stateSave: true,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
